import { render } from "./App.vue?vue&type=template&id=127d923a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=127d923a&lang=css"

import exportComponent from "/home/gowtham/Downloads/CM workspace/gamma-verhuizen-new/gamma-verhuizen-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__